<div class="panel-body">
    <div x-shift-bar-graph="" x-options="config" style="height: 100%;"></div>
</div>
